import { DateTime } from 'luxon';
import { DISPLAY_FORMAT } from '../constants';
import toLuxonObject from './toLuxonObject';

export default function toLocalizedDateString(date, currentFormat) {
  const dateObj = (date instanceof DateTime) ? date : toLuxonObject(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.toFormat(DISPLAY_FORMAT);
}
